<template>
  <div class="our-client">
    <b-container>
      <h1 class="section-title">{{$t('our-client-section-1-title')}}</h1>
      <b-row>
        <b-col v-for="(imgSrc, index) in images" :key=index class="mb-5" cols="12" xl="4" md="4" sm="6">
          <div class="card user-case-card">
            <div class="img">
              <b-img class="img-head-contain" :src="imgSrc"></b-img>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import runtime from '../utils/runtime'

const cilentImgFiles = require.context('../assets/imgs/clients', false, /\.(png|jpe?g|svg|git)$/)

const images = cilentImgFiles.keys().reduce((acc, key) => {
  acc[key] = cilentImgFiles(key)
  console.log(acc)
  return acc
}, {})

export default {
  name: 'Client',
  data () {
    return {
      isMobile: runtime.isMobile(),
      images: images
    }
  },
  methods: {
    linkTo (url) {
      window.location.href = url
    }
  }
}

</script>
<style lang="scss" scoped>
  .our-client {
    .platform-title-img {
      width: 50%;
      bottom: 30px;
      right: 30px;
    }

    .section-title {
      font-size: 2rem;
      font-weight: bold;
      margin-top: 60px;
      margin-bottom: 40px;
    }

    .card {
      box-shadow: 0px 3px 31px 0px rgba(0,0,0,0.16);
      transition: all .3s ease-out;

      &:hover {
        box-shadow: 0px 3px 31px 0px rgba(0,0,0,0.3);
      }

      .img {
        position: relative;
        .img-head {
          height: 250px;
          object-fit: cover;
          width: 100%;
        }
        .img-head-contain {
          height: 270px;
          object-fit: contain;
          width: 100%;
          border: 1px solid #999999;
        }
        &.mask:before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 5;
          background-color: rgba(190, 112, 255, 0.3);
        }
      }
      .show-calendar {
        display: flex;
        font-size: 16px;
        margin: 15px;

        img {
          width: 18px;
          margin-right: 10px;
          align-self: center;
        }
      }
      p {
        font-size: 20px;
        font-weight: bold;
        padding: 0 15px;
        line-height: 1.2;
      }
      button {
        text-align: left;
        outline: none;
        text-underline: none;

        &:focus {
          box-shadow: none;
          text-underline: none;
        }
      }

      &.user-case-card {
        .img {
          position: relative;
          .img-head {
            height: 270px;
          }
        }
        p {
          padding: 30px 15px;
        }
      }
    }
  }
</style>
